import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/tenant/settings/root'

export const generalRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/general',
    component: lazyRouteComponent(() => import('./General'), 'General'),
})
